export interface IEffectiveUnitNodeCompanyIds {
    companyIds: string[];
    isExplicitPermission: boolean;
}

export class EffectiveUnitNodeCompanyIds implements IEffectiveUnitNodeCompanyIds {
    companyIds: string[];
    isExplicitPermission: boolean;

    constructor();
    constructor(obj: IEffectiveUnitNodeCompanyIds);
    constructor(obj?: any) {
        this.companyIds = obj && obj.companyIds || [];
        this.isExplicitPermission = obj && obj.isExplicitPermission || false;
    }
}